export default "__VITE_ASSET__92db985e__"